import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtBRL, fmtDate } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function Invoices() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/invoices").then((r) => setItems(r.data)); }, []);

  const badge = (s) => {
    const map = {
      paid: "bg-emerald-500/20 text-emerald-400 border-emerald-500/30",
      pending: "bg-amber-500/20 text-amber-400 border-amber-500/30",
      overdue: "bg-red-500/20 text-red-400 border-red-500/30",
      cancelled: "bg-zinc-500/20 text-zinc-400 border-zinc-500/30",
    };
    return <Badge className={`rounded-sm border ${map[s] || map.cancelled}`}>{s}</Badge>;
  };

  return (
    <div className="space-y-8" data-testid="invoices-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-2">// faturas</div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tighter">Suas faturas</h1>
      </div>
      <div className="border border-white/10 bg-[#121214]">
        {items.length === 0 ? (
          <div className="p-10 text-center text-zinc-500">Nenhuma fatura ainda.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-xs font-mono uppercase tracking-widest text-zinc-500">
              <tr className="border-b border-white/10">
                <th className="text-left px-5 py-3">Número</th>
                <th className="text-left px-5 py-3">Plano</th>
                <th className="text-left px-5 py-3">Vencimento</th>
                <th className="text-left px-5 py-3">Valor</th>
                <th className="text-left px-5 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.invoice_id} className="border-b border-white/5 hover:bg-white/5" data-testid={`invoice-list-row-${i.invoice_id}`}>
                  <td className="px-5 py-3 font-mono"><Link to={`/dashboard/invoices/${i.invoice_id}`} className="hover:underline">{i.number}</Link></td>
                  <td className="px-5 py-3">{i.plan_name}</td>
                  <td className="px-5 py-3 font-mono text-xs">{fmtDate(i.due_at)}</td>
                  <td className="px-5 py-3 font-mono">{fmtBRL(i.amount_brl)}</td>
                  <td className="px-5 py-3">{badge(i.status)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
